module.exports = __webpack_public_path__ + "static/media/NokiaPureHeadline_Rg.d10dc635.ttf";